
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testdrive",
      function () {
        return require("private-next-pages/testdrive.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testdrive"])
      });
    }
  